export const USER_WELCOMED = 'USER_WELCOMED'
export const USER_COOKIE_TOKEN = 'USER_COOKIE_TOKEN'
export const USER_GUEST = 'USER_GUEST'
export const USER_THEME = 'USER_THEME'
export const ADD_HOME_TIMESTAMP = 'ADD_HOME_TIMESTAMP'
export const SHARE_ASKED_TIMESTAMP = 'SHARE_ASKED_TIMESTAMP'
export const PLZ_LOGIN_TIMESTAMP = 'PLZ_LOGIN_TIMESTAMP'
export const USER_READ_CRIMES_TIMESTAMP = 'USER_READ_CRIMES_TIMESTAMP'
export const USER_READ_DISCOUNT_NOTES = 'USER_READ_TAKHFIF_NOTES'
export const USER_READ_UPDATES_ID = 'USER_READ_UPDATES_ID'
export const USER_RATE_EATERY = 'USER_RATE_EATERY'

export const SESSION_USER_SUMMARY_KEY = 'SESSION_USER_SUMMARY_KEY'
